import { render, staticRenderFns } from "./usertable.vue?vue&type=template&id=5b8cb716&scoped=true&"
import script from "./usertable.vue?vue&type=script&lang=js&"
export * from "./usertable.vue?vue&type=script&lang=js&"
import style0 from "./usertable.vue?vue&type=style&index=0&id=5b8cb716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cb716",
  null
  
)

export default component.exports